import { Power1, Power3, gsap, Elastic } from "gsap";

import _Header from '../_app/cuchillo/layout/Header';
import { GetBy } from "../_app/cuchillo/core/Element";
import { Basics, isMobile } from "../_app/cuchillo/core/Basics";

export default class Header extends _Header {
  static links;
  static target;
  static current = null;
  static projecN;
  static wrapper;
  static size = {
    x: 0,
    y: 0
  };

  static options = {
    show: {
      duration: .3,
      delay: 0,
      ease: Power3.easeOut
    },
    hide: {
      duration: .3,
      delay: 0,
      ease: Power3.easeIn
    }
  }

  static init() {
    super.init();

    this.target = GetBy.class('__target', this.container)[0];
    this.wrapper = GetBy.class('__wrapper', this.container)[0];
    this.links = [...GetBy.class('__link', this.container)];

    this._projectN = GetBy.selector('sup', this.container)[0];
    this.directHideProjectsN();

    this.resize();
    this.directHide();
  }

  static directHide() {
    this.isShow = false;
    gsap.set(this.container, { opacity: 0, width: this.size.y });
    gsap.set(this.wrapper, { opacity: 0 });
    gsap.set(this.target, { opacity: 0 });
  }

  static show__effect() {
    gsap.to(this.container, { opacity: 1, duration: .3, ease: Power1.easeOut });
    gsap.to(this.container, { width: this.size.x, duration: 1.3, ease: Elastic.easeOut.config(1, .7) });
    gsap.to(this.wrapper, { opacity: 1, duration: .3, delay: 1, ease: Power1.easeOut });
    gsap.to(this.target, { opacity: 1, duration: .3, delay: 1, ease: Power1.easeOut });
  }

  static loop() { }

  static sendUp() {
    if (isMobile) return;

    document.body.classList.remove('--header-bottom');
    this.container.classList.add('--top');
  }

  static sendDown() {
    if (isMobile) return;

    document.body.classList.add('--header-bottom');
    this.container.classList.remove('--top');
  }

  static showProjectsN() {
    gsap.to(this._projectN, { scaleX: 1, scaleY: 1, duration: 1, ease: Elastic.easeOut.config(1, .5) });
    gsap.to(this._projectN, { opacity: 1, duration: .1, ease: Power1.easeInOut });
  }

  static hideProjectsN() {
    gsap.to(this._projectN, { scaleX: 0, scaleY: 0, duration: 1, ease: Elastic.easeIn.config(1, .5) });
    gsap.to(this._projectN, { opacity: 0, duration: .1, delay: .9, ease: Power1.easeInOut });
  }

  static directHideProjectsN() { gsap.set(this._projectN, { scaleX: 0, scaleY: 0, opacity: 0 }); }

  static setProjectsN(__n) { this._projectN.innerHTML = __n; }

  static selectPage(firstTime = false) {
    const link = this.links.filter(link => link.getAttribute('aria-current') === 'page')[0];

    if (firstTime && link) {
      this.directShowTarget(link);
    } else if (link) {
      this.showTarget(link);
    } else {
      this.hideTarget();
    }
  }

  static hideTarget() {
    this.current = null;

    gsap.killTweensOf(this.target);
    gsap.to(this.target, {
      opacity: 0,
      duration: .4,
      ease: Power3.easeOut
    });
  }

  static directShowTarget(link) {
    this.current = link;

    const { width } = link.getBoundingClientRect();
    gsap.set(this.target, {
      width: width,
      left: link.offsetLeft
    });
  }

  static showTarget(link) {
    gsap.killTweensOf(this.target);

    if (this.current === link) return;
    this.current = link;

    const { width } = link.getBoundingClientRect();

    gsap.to(this.target, {
      opacity: 1,
      duration: .4,
      delay: .3,
      ease: Power3.easeOut
    });

    if (this.target.offsetLeft < link.offsetLeft) {
      gsap.to(this.target, {
        width: width * 1.5,
        duration: .5,
        ease: Power3.easeInOut
      });
      gsap.to(this.target, {
        width: width,
        left: link.offsetLeft,
        duration: .7,
        delay: .2,
        ease: Power3.easeOut
      });
    } else {
      gsap.to(this.target, {
        width: width * 1.3,
        duration: .5,
        ease: Power3.easeOut
      });
      gsap.to(this.target, {
        left: link.offsetLeft,
        duration: .7,
        ease: Power3.easeOut
      });
      gsap.to(this.target, {
        width,
        duration: .4,
        delay: .2,
        ease: Power3.easeInOut
      });
    }
  }

  static resize() {
    super.resize();

    this.size.x = this.wrapper.offsetWidth;
    this.size.y = this.wrapper.offsetHeight;

    if (!this.isShow) return;
    gsap.set(this.container, { width: this.size.x });
  }
}
